/**
 * Search 搜索页面翻译
 */

import type { TranslationDict } from '../types';

export const search: TranslationDict = {
  placeholder: {
    en: 'Search posts, users, topics...',
    'zh-CN': '搜索帖子、用户、话题...',
    ja: '投稿、ユーザー、トピックを検索...',
  },
  recent: {
    en: 'Recent Searches',
    'zh-CN': '最近搜索',
    ja: '最近の検索',
  },
  clearAll: {
    en: 'Clear all',
    'zh-CN': '清空全部',
    ja: 'すべてクリア',
  },
  trending: {
    en: 'Trending',
    'zh-CN': '热门搜索',
    ja: 'トレンド',
  },
  results: {
    en: 'Results',
    'zh-CN': '搜索结果',
    ja: '検索結果',
  },
  noResults: {
    en: 'No results found',
    'zh-CN': '未找到结果',
    ja: '結果が見つかりません',
  },
  noResultsFor: {
    en: 'No results for "{{query}}"',
    'zh-CN': '未找到 "{{query}}" 的相关结果',
    ja: '"{{query}}" の検索結果は見つかりませんでした',
  },
  tryDifferent: {
    en: 'Try different keywords or check your spelling',
    'zh-CN': '尝试不同的关键词或检查拼写',
    ja: '別のキーワードを試すか、スペルを確認してください',
  },
  tabs: {
    all: {
      en: 'All',
      'zh-CN': '全部',
      ja: 'すべて',
    },
    posts: {
      en: 'Posts',
      'zh-CN': '帖子',
      ja: '投稿',
    },
    users: {
      en: 'Users',
      'zh-CN': '用户',
      ja: 'ユーザー',
    },
    circles: {
      en: 'Circles',
      'zh-CN': '圈子',
      ja: 'サークル',
    },
  },
  creator: {
    title: { en: 'Creator Program', 'zh-CN': '创作者计划', ja: 'クリエイタープログラム' },
    tagline: {
      en: 'Earn from your audience, unlock analytics, and reach more readers.',
      'zh-CN': '从你的受众获得收入，解锁数据洞察，触达更多读者。',
      ja: 'オーディエンスから収益を得て、分析を解放し、より多くの読者にリーチ。',
    },
    benefit1: { en: 'Tipping & subscriptions', 'zh-CN': '打赏 & 订阅', ja: 'チップと購読' },
    benefit2: { en: 'Audience insights',       'zh-CN': '受众数据',     ja: 'オーディエンス分析' },
    benefit3: { en: 'Verified creator badge',  'zh-CN': '认证创作者徽章', ja: '認証クリエイターバッジ' },
    cta: { en: 'Join now', 'zh-CN': '立即加入', ja: '今すぐ参加' },
  },
  discover: {
    forYou:        { en: 'For You',       'zh-CN': '为你推荐', ja: 'おすすめ' },
    trending:      { en: 'Trending',      'zh-CN': '热门',     ja: 'トレンド' },
    news:          { en: 'News',          'zh-CN': '新闻',     ja: 'ニュース' },
    sports:        { en: 'Sports',        'zh-CN': '体育',     ja: 'スポーツ' },
    entertainment: { en: 'Entertainment', 'zh-CN': '娱乐',     ja: 'エンタメ' },
    whoToFollow:   { en: 'Who to follow', 'zh-CN': '推荐关注', ja: 'おすすめユーザー' },
    follow:        { en: 'Follow',        'zh-CN': '关注',     ja: 'フォロー' },
    showMore:      { en: 'Show more',     'zh-CN': '查看更多', ja: 'もっと見る' },
    empty:         { en: 'Nothing here yet.', 'zh-CN': '暂无内容。', ja: 'まだ何もありません。' },
  },
  suggestions: {
    users: {
      en: 'Users',
      'zh-CN': '用户',
      ja: 'ユーザー',
    },
    posts: {
      en: 'Posts',
      'zh-CN': '帖子',
      ja: '投稿',
    },
  },
  sections: {
    users: {
      en: 'Users',
      'zh-CN': '用户',
      ja: 'ユーザー',
    },
    posts: {
      en: 'Posts',
      'zh-CN': '帖子',
      ja: '投稿',
    },
  },
  follow: {
    en: 'Follow',
    'zh-CN': '关注',
    ja: 'フォロー',
  },
  unfollow: {
    en: 'Unfollow',
    'zh-CN': '取消关注',
    ja: 'フォロー解除',
  },
  aria: {
    search: {
      en: 'Search',
      'zh-CN': '搜索',
      ja: '検索',
    },
    clearSearch: {
      en: 'Clear search',
      'zh-CN': '清除搜索',
      ja: '検索をクリア',
    },
    removeFromHistory: {
      en: 'Remove from history',
      'zh-CN': '从历史记录中移除',
      ja: '履歴から削除',
    },
  },
};
